import React, { ReactNode } from 'react';
import { Grid } from '@material-ui/core';
import { LayoutFormHeader } from './LayoutFormHeader/LayoutFormHeader';
import { useLayoutFormStyles } from './LayoutForm.styles';

export interface IFormLayoutProps {
    footer?: ReactNode;
    children: ReactNode;
}

export const LayoutForm = ({ children, footer }: IFormLayoutProps) => {
    const classes = useLayoutFormStyles();

    return (
        <Grid className={classes.container} container>
            <Grid item className={classes.formContainer}>
                <LayoutFormHeader />
                {children}
                {footer}
            </Grid>
        </Grid>
    );
};
